import { useEffect, useState, type ReactNode } from 'react';

export default function RequireAuth({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<'checking' | 'authed'>('checking');

  useEffect(() => {
    let cancelled = false;

    // Never interfere with SWA's own auth handshake routes
    if (window.location.pathname.startsWith('/.auth')) {
      setStatus('authed');
      return;
    }

    fetch('/.auth/me')
      .then((r) => r.json())
      .then((d) => {
        if (cancelled) return;
        if (d?.clientPrincipal) {
          // Signed in — clear any pending-login marker and show the app
          sessionStorage.removeItem('auth_redirecting');
          setStatus('authed');
          return;
        }
        // Not signed in. Only redirect ONCE — if we already tried, stop to avoid a loop.
        if (sessionStorage.getItem('auth_redirecting') === '1') {
          // We came back still unauthenticated — don't loop; show the app shell.
          sessionStorage.removeItem('auth_redirecting');
          setStatus('authed');
          return;
        }
        sessionStorage.setItem('auth_redirecting', '1');
        const dest = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/.auth/login/aad?post_login_redirect_uri=${dest}`;
      })
      .catch(() => {
        // On error, don't loop — just render.
        if (!cancelled) setStatus('authed');
      });

    return () => { cancelled = true; };
  }, []);

  if (status === 'checking') {
    return <div className="min-h-screen bg-bg-base" />;
  }
  return <>{children}</>;
}
